/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleEntity } from '../../models/schedule-entity';

export interface GetSchedule$Params {
  location_id: string;
}

export function getSchedule(http: HttpClient, rootUrl: string, params: GetSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleEntity>> {
  const rb = new RequestBuilder(rootUrl, getSchedule.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleEntity>;
    })
  );
}

getSchedule.PATH = '/locations/{location_id}/optimizer/schedule';
